import ICWarning from 'assets/icons/warning-icon.svg'
import CustomButton from 'components/Buttons/CustomButton'
import { useSnackbar } from 'notistack'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, ModalBody } from 'reactstrap'
import { useDeleteEventParticipantMutation } from './eventParticipantApiSlice'

const ModalDelete = ({ row, isOpen, toggle, refetch }) => {
  const dispatch = useDispatch()
  const [deleteEventParticipant, result] = useDeleteEventParticipantMutation()
  const { enqueueSnackbar } = useSnackbar()

  const handleSubmit = async () => {
    try {
      let body = {
        id: row?.id,
        eventId: row?.eventId
      }

      const resp = await deleteEventParticipant(body).unwrap()
      if (!resp?.data?.error) {
        enqueueSnackbar('Berhasil menghapus peserta event.', {
          variant: 'success',
        })
        toggle()
        refetch()
      } else {
        throw resp
      }
    } catch (error) {
      enqueueSnackbar(error?.data?.message ?? error?.message, {
        variant: 'error',
      })
    }
  }

  return (
    <Modal
      centered
      toggle={toggle}
      isOpen={isOpen}
      data-testid="event-participant-modal-delete"
    >
      <ModalBody>
        <img src={ICWarning} alt="Warning Icon" />
        <h6 className="mt-4 fw-600">Hapus Peserta Event</h6>
        <span>
          Apakah kamu yakin ingin menghapus peserta ini?. Jika kamu menghapus
          peserta ini, maka peserta akan hilang dan tidak bisa dikembalikan
          lagi.
        </span>

        <div className="d-flex gap-3 mt-4">
          <CustomButton
            onClick={toggle}
            block
            outline
            className="btn-cancel"
            testId="event-participant-modal-delete-cancel-button"
          >
            Batal
          </CustomButton>
          <CustomButton
            onClick={handleSubmit}
            disabled={result?.isLoading}
            block
            color="danger"
            testId="event-participant-modal-delete-submit-button"
          >
            Hapus
          </CustomButton>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalDelete
